export enum enumMarineInsuranceEntityType {
  ISF = 'ISF',
  ENTRY_SUMMARY = 'Entry Summary',
  LCL_QUOTE = 'Quote',
  LCL_SHIPPING = 'Shipping',
}
